import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { AdminShell } from '../components/admin/AdminShell';
import type { AdminTab } from '../components/admin/AdminShell';
import { EventsTab } from '../components/admin/EventsTab';
import { MembersTab } from '../components/admin/MembersTab';
import { SiteInfoSettings } from '../components/admin/SiteInfoSettings';

export const AdminDashboard = () => {
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState<AdminTab>('leden');

  return (
    <AdminShell activeTab={activeTab} onTabChange={setActiveTab} onLogout={logout}>
      {activeTab === 'leden' && <MembersTab />}
      {activeTab === 'evenementen' && <EventsTab />}
      {activeTab === 'siteinfo' && <SiteInfoSettings />}
    </AdminShell>
  );
};
